import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

import { TABLET_MIN } from '../constants/styledComponents';

const SidebarContext = createContext();

export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider = ({ children }) => {
  // Visible by default on tablet (rail) and desktop (full); mobile starts hidden.
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    typeof window === 'undefined' || window.innerWidth >= TABLET_MIN,
  );

  const toggleSidebar = useCallback(() => setIsSidebarOpen((isOpen) => !isOpen), []);
  const closeSidebar = useCallback(() => setIsSidebarOpen(false), []);
  const openSidebar = useCallback(() => setIsSidebarOpen(true), []);

  const value = useMemo(
    () => ({ isSidebarOpen, toggleSidebar, closeSidebar, openSidebar }),
    [isSidebarOpen, toggleSidebar, closeSidebar, openSidebar],
  );

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};

export { SidebarContext };
